import { render } from "./NewMailsCreate.vue?vue&type=template&id=1b86c1f8"
import script from "./NewMailsCreate.vue?vue&type=script&lang=js"
export * from "./NewMailsCreate.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__